<template>
  <div class="ma-6">
    <v-dialog v-model="dialog" persistent width="700">
      <v-card>
        <v-card-title class="primary white--text">Tambah Banner</v-card-title>
        <v-card-text>
          <v-form lazy-validation>
            <v-text-field v-model="newdata.caption" name="judul" label="Judul"></v-text-field>
            <div>
              <ImageBannerUploader @setimage="onsetImage"  :value="newdata.image" label="Upload Image File"/>
            </div>
            <v-row>
              <v-col cols="12" lg="6">
                <v-dialog
                    ref="dialog"
                    v-model="modaldate"
                    :return-value.sync="newdata.expdate"
                    persistent
                    width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                        v-on="on"
                        v-model="newdata.expdate"
                        label="Expire Date">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="newdata.expdate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modaldate = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(newdata.expdate)">OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" lg="6">
                <v-text-field type="number" v-model="newdata.sortorder" name="nourut" label="No Urut"></v-text-field>
              </v-col>
            </v-row>
            <v-switch
                flat icon
                inset
                v-model="statusSlider"
                label="Status"/>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn dark text @click="setdialog(false)" class="red">Tutup</v-btn>
          <v-btn @click.native="simpandata"  elevation="0" color="primary">Simpan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="page-header-left">
      <h2 class="pr-3">Banner</h2>
      <v-spacer></v-spacer>
    </div>
    <div class="mt-4 pr-0 pl-0 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)">
      <v-toolbar elevation="0">
        <v-text-field
            flat
            solo
            clearable
            prepend-icon="search"
            placeholder="Type something"
            v-model="search"
            hide-details
            class=""
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn @click.native="tambah" small outlined elevation="0" class="ml-2" color="primary">
          <v-icon dark>add</v-icon>Tambah
        </v-btn>
        <v-btn small outlined elevation="0" class="ml-2" color="primary" @click.native="getSlider">
          <v-icon dark>refresh</v-icon>Refresh
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
        <v-data-table
            dense
            sort-by="id"
            :sort-desc="sortdes"
            :headers="headers"
            :search="search"
            :items="sliders"
            class="elevation-0"
            item-key="id"
            :loading="loading"
            @update:options="getSlider">
          <template v-slot:item.image="{ item }">
                  <v-img width="500" class="ma-4" :src="item.image"></v-img>
          </template>
          <template v-slot:item.status="{ item }">
            <div class="ma-4 text-xs-left">
              <v-chip
                  :color="colorStatus(item.status)"
                  small
                  text-color="white">
                {{ statusText(item.status) }}
              </v-chip>
            </div>
          </template>
          <template v-slot:item.aksi="{ item }">
            <v-btn text dark fab x-small @click="edit(item)" class="accent"><v-icon small dark>edit</v-icon></v-btn>
          </template>
        </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ImageBannerUploader from '@/components/ImageBannerUploader'

export default {
  name: 'Sliders',
  components: { ImageBannerUploader },
  data: () => ({
    sortdes: [true],
    modaldate: false,
    editing: false,
    date: new Date().toISOString().substr(0, 10),
    newdata: {
      image: '',
      caption: '',
      expdate: '',
      sortorder: 1,
      status: 0
    },
    search: '',
    headers: [
      {
        text: 'Id',
        value: 'id'
      },
      {
        text: 'Image',
        value: 'image'
      },
      {
        text: 'Caption',
        value: 'caption'
      },
      {
        text: 'Expired Date',
        value: 'expdate'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        text: 'Aksi',
        value: 'aksi'
      }
    ]
  }),
  mounted () {
    this.getSlider()
  },
  computed: {
    ...mapState('AdminSliders', ['dialog', 'loading', 'sliders']),
    statusSlider: {
      get () {
        return parseInt(this.newdata.status) === 1
      },
      set (val) {
        if (val) {
          this.newdata.status = '1'
        } else {
          this.newdata.status = '0'
        }
      }
    }
  },
  methods: {
    ...mapActions('AdminSliders', ['getSlider', 'setdialog', 'deleteSlider', 'addSlider', 'editSlider', 'deleteSlider']),
    colorStatus (val) {
      if (parseInt(val) === 0) {
        return 'red'
      }
      if (parseInt(val) === 1) {
        return 'green'
      }
    },
    statusText (val) {
      if (parseInt(val) === 0) {
        return 'Non Aktif'
      }
      if (parseInt(val) === 1) {
        return 'Aktif'
      }
    },
    tambah () {
      this.editing = false
      this.$emit('clearupload')
      this.setdialog(true)
      this.newdata.image = 'x'
      this.newdata = {
        image: '',
        caption: '',
        expdate: '',
        sortorder: 0
      }
    },
    edit (item) {
      this.editing = true
      this.newdata = item
      this.setdialog(true)
      console.log(item)
    },
    openfile () {
      this.$refs.imageupload.click()
    },
    upload: function (files) {
      this.showPreview(files[0])
    },
    onsetImage (data) {
      console.log('EVENT:' + data)
      this.newdata.image = data
    },
    simpandata () {
      if (this.editing) {
        this.editSlider(this.newdata)
      } else {
        this.addSlider(this.newdata)
      }
    }
  }
}
</script>

<style scoped>

</style>
